import type React from 'react';
import { useTranslation } from 'react-i18next';
import '../HeyGenAvatar.css';

interface QueueOverlayProps {
  isInQueue: boolean;
  isQueueReady: boolean;
  queuePosition: number | null;
  totalInQueue: number | null;
  queueCountdown: number | null;
  onClaimSlot: () => void;
  onLeaveQueue: () => void;
}

/** Overlay shown when user is in the waiting queue */
export const QueueOverlay: React.FC<QueueOverlayProps> = ({
  isInQueue,
  isQueueReady,
  queuePosition,
  totalInQueue,
  queueCountdown,
  onClaimSlot,
  onLeaveQueue,
}) => {
  const { t } = useTranslation();

  if (!isInQueue) return null;

  return (
    <div className="heygen-avatar-queue-overlay">
      <div className="heygen-avatar-queue-content">
        {isQueueReady ? (
          <>
            <h3>{t('avatar.queue.yourTurn', "It's your turn!")}</h3>
            <p className="heygen-avatar-queue-countdown">
              {t('avatar.queue.startIn', 'Click to start. Time remaining: {{seconds}}s', {
                seconds: queueCountdown,
              })}
            </p>
            <div className="heygen-avatar-queue-buttons">
              <button type="button" className="heygen-avatar-queue-start-btn" onClick={onClaimSlot}>
                {t('avatar.queue.startNow', 'Start Now')}
              </button>
              <button
                type="button"
                className="heygen-avatar-queue-leave-btn"
                onClick={onLeaveQueue}
              >
                {t('avatar.queue.leave', 'Leave Queue')}
              </button>
            </div>
          </>
        ) : (
          <>
            <h3>{t('avatar.queue.waiting', 'Waiting in Queue')}</h3>
            <p className="heygen-avatar-queue-position">
              {t('avatar.queue.positionOfTotal', 'You are {{position}} of {{total}} in queue', {
                position: queuePosition,
                total: totalInQueue,
              })}
            </p>
            <p className="heygen-avatar-queue-info">
              {t(
                'avatar.queue.info',
                'All avatars are currently busy. You will be notified when a slot opens.',
              )}
            </p>
            <button type="button" className="heygen-avatar-queue-leave-btn" onClick={onLeaveQueue}>
              {t('avatar.queue.leave', 'Leave Queue')}
            </button>
          </>
        )}
      </div>
    </div>
  );
};
